export const BASE_URL = `${process.env.REACT_APP_BASE_API}/api`;
export const inProduction = process.env.REACT_APP_NODE_ENV === 'production';
export const headerConfig = ()=>{
    const token = localStorage.getItem("token");
    const headers = {
        withCredentials:true,
        headers: {
            Authorization:`Bearer ${token}`,
            "Cache-Control": "no-cache, must-revalidate, proxy-revalidate"
        },
    }
    return headers;
}
export const getTimeAgo = (date) => {
	const now = new Date();
	const created = new Date(date);
	const diffMs = now - created;
	const diffMins = Math.floor(diffMs / (1000 * 60));
	if (diffMins < 60) return `${diffMins} minute${diffMins !== 1 ? 's' : ''} ago`;
	const diffHours = Math.floor(diffMins / 60);
	if (diffHours < 24) return `${diffHours} hour${diffHours !== 1 ? 's' : ''} ago`;
	const diffDays = Math.floor(diffHours / 24);
	return `${diffDays} day${diffDays !== 1 ? 's' : ''} ago`;
};

export function getInitials(name) {
  if (!name) return 'N/A';

  return name
    .split(' ')                      // Split by spaces
    .filter(word => word.length > 0) // Remove empty strings
    .map(word => word[0].toUpperCase()) // Take first letter and capitalize
    .join('');
}
export const paginationOptions = [
	{ value: 2, label: '2 items' },
	{ value: 4, label: '4 items' },
	{ value: 6, label: '6 items' },
	{ value: 12, label: '12 items' },
	{ value: 24, label: '24 items' },
	{ value: 48, label: '48 items' },
];
export const fileExpires = [
	{
		label: "1 min",
		value: '1m',
	},
	{
		label:"2 min",
		value: '2m',
	},
	{
		label: "10 min",
		value: '10m',
	},
	{
		label: "30 min",
		value: '30m',
	},
	{
		label: "1 Hour",
		value: '60m',
	},
	{
		label: "1 Day",
		value: '1',
	},
	{
		label: "3 Days",
		value: '3',
	},
	{
		label: "7 Days",
		value: '7',
	},
	{
		label: "14 Days",
		value: '14',
	},
	{
		label: "30 Days",
		value: '30',
	},
	{
		label: "90 Days",
		value: '90',
	},
]
export const formatBytes = (bytes, decimals = 2) => {
	if (bytes === 0) return '0 Bytes';

	const k = 1024;
	const dm = decimals < 0 ? 0 : decimals;
	const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

	const i = Math.floor(Math.log(bytes) / Math.log(k));

	return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};